import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SharedService } from './shared.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PromoCodeService {

  private jsonOptions = {
    headers: new HttpHeaders().set('Accept', 'application/json').set('Content-Type', 'application/json')
  };

  constructor(private http: HttpClient, private sharedService: SharedService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(error as T);
    };
  }

  getAllPromoCode(filter: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/get/all/promo/codes', filter, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getAllPromoCode', []))
    );
  }

  createPromoCode(value: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl() + 'admin/create/promo/code' , value, this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('createPromoCode', []))
    );
  }

  getPromoCode(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'admin/promo/code/single/'+id,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getPromoCode', []))
    )
  }

  addUserToPromoCode(obj: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+ 'admin/add/user/to/promo',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('addUserToPromoCode', []))
    )
  }

  getPromoCodeUsage(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'admin/promo/code/usage/'+id,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getPromoCode', []))
    )
  }

  getPromoCodeForUser(id: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'promo/code/user/'+id,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getPromoCodeForUser', []))
    )
  }

  getPromoByCode(promoCode: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+'promo/code/'+promoCode,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('getPromoByCode', []))
    )
  }

  downloadPromoCodeTemplate(): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl()+ 'promo/code/template',this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('downloadPromoCodeTemplate', []))
    )
  }

  uploadUsersFiles(file: any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+'promo/code/upload/users',file,
      {
        headers: new HttpHeaders().set('Accept', 'application/json')
      }).pipe(
      catchError(this.handleError<any[]>('uploadUsersFiles', []))
    )
  }

  addUsers(obj:any): Observable<any> {
    return this.http.post(this.sharedService.getFranchiseUrl()+'promo/code/add/users',obj,this.jsonOptions).pipe(
      catchError(this.handleError<any[]>('addUsers', []))
    )
  }

  canUserUsePromo(promoCode: any, accountNo: any): Observable<any> {
    return this.http.get(this.sharedService.getFranchiseUrl() + 'promo/code/usage/for/'+accountNo+'/'+promoCode).pipe(
      catchError(this.handleError<any[]>('canUserUsePromo', []))
    )
  }
}
